export const isPrintshopPage = () => {
  return window.location.href.includes('printshop');
};
